var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SiteInput',{ref:"geo",attrs:{"name":"location","value":_vm.value,"label":_vm.label || _vm.t.label_location,"autocomplete":"off"},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }